export function createNameIdentifierForMaterialEdgeTestKey(
  sourceMethodName: string,
  sourceMaterialName: string,
  targetMethodName: string,
  targetMaterialName: string
): string {
  return `${sourceMethodName}-${sourceMaterialName}-${targetMethodName}-${targetMaterialName}`;
}
